/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_MarketingInputs */

const tr_mascot_chat_marketing = /** @type {(inputs: Mascot_Chat_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampanya ve fırsatlardan e-posta ile haberdar olmak istiyorum (isteğe bağlı).`)
};

const en_mascot_chat_marketing = /** @type {(inputs: Mascot_Chat_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'd like to receive emails about campaigns and offers (optional).`)
};

const de_mascot_chat_marketing = /** @type {(inputs: Mascot_Chat_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich möchte über Angebote und Aktionen per E-Mail informiert werden (optional).`)
};

const ru_mascot_chat_marketing = /** @type {(inputs: Mascot_Chat_MarketingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я хочу получать информацию об акциях и предложениях по e-mail (необязательно).`)
};

/**
* | output |
* | --- |
* | "I'd like to receive emails about campaigns and offers (optional)." |
*
* @param {Mascot_Chat_MarketingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_marketing = /** @type {((inputs?: Mascot_Chat_MarketingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_MarketingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_marketing(inputs)
	if (locale === "de") return de_mascot_chat_marketing(inputs)
	if (locale === "ru") return ru_mascot_chat_marketing(inputs)
	return tr_mascot_chat_marketing(inputs)
});